<div
    class="container-brand-logo d-inline-flex justify-content-center align-items-center"
    [class.bg-gray-lighter]="!logo"
>
    @if (logo) {
        <app-lib-image-loader
            src="assets/img/credit-card-types/{{ logo | imgType | async }}.svg"
            [alt]="logo + '-logo'"
            [title]="logo + '-logo'"
            [width]="width"
            [height]="height"
        />
    }
</div>
